module.exports = __webpack_public_path__ + "img/ph-face.4774c991.png";